export const SALESFORCE_PREFERENCES_COPY = {
	SECTION_HEADER: 'Salesforce Preferences',
	USE_LIGHTNING_URLS: 'Use Lightning URLs'
};
